import type { ReactNode } from 'react';

export type TextProps = {
  children: ReactNode;
  size?: TextSizeClasses;
  color?: string;
  weight?: TextWeightClasses;
  className?: string;
  align?: TextAlignClasses;
};

export type TextAlignClasses = 'text-center' | 'text-end' | 'text-start';

export type TextSizeClasses =
  | 'text-xs'
  | 'text-sm'
  | 'text-base'
  | 'text-lg'
  | 'text-xl'
  | 'text-2xl'
  | 'text-3xl'
  | 'text-4xl'
  | 'text-5xl'
  | 'text-6xl'
  | 'text-7xl'
  | 'text-8xl'
  | 'text-9xl';

type TextWeightClasses =
  | 'font-thin'
  | 'font-extralight'
  | 'font-light'
  | 'font-normal'
  | 'font-medium'
  | 'font-semibold'
  | 'font-bold'
  | 'font-extrabold';

export const Text = ({
  children,
  size = 'text-base',
  color = 'text-black',
  weight = 'font-normal',
  align = 'text-start',
  className,
}: TextProps) => {
  const textSize = size;
  const textWeight = weight;
  const textColor = color;

  return (
    <span
      className={`${textSize} ${align} ${textColor} ${textWeight} ${className}`}
    >
      {children}
    </span>
  );
};
